import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class DataService {

    private backendBaseUrl = environment.backendUrl;

    constructor(private http: HttpClient,) {
    }

    /**
     * Get a structure (a menu) from the backend
     */
    getStructure(structureId: String): Observable<any> {
        const sectionsUrl = `${this.backendBaseUrl}/?menu=${structureId}`;
        return this.http.get(sectionsUrl)
            .map((res: Response) => res);
    }

    /**
     * Get a list of posts (sort by post type and/or category)
     */
    getPosts(postType: String, category: any, limit: Number = -1, skip: any = ''): Observable<any> {
        let postsUrl = `${this.backendBaseUrl}/_posts?post_type=${postType}&limit=${limit}&skip=${skip}`;
        if (category) {
            postsUrl = `${this.backendBaseUrl}/_posts?post_type=${postType}&category=${category}&limit=${limit}&skip=${skip}`;
        }

        return this.http.get(postsUrl)
            .map((res: Response) => res);
    }

    /**
     * Get a single post using the post slug
     */
    getPost(slug: String): Observable<any> {
        const postUrl = `${this.backendBaseUrl}/${slug}`;

        return this.http.get(postUrl)
            .map((res: Response) => res);
    }

    /**
     * Get an ACF field value
     */
    getField(path: String = null, postId: any = null, fieldId: String) {
        const fieldUrl = `${this.backendBaseUrl}/${path}/?acf_field=${fieldId}&post_id=${postId}`;
        return this.http.get(fieldUrl)
            .map((res: Response) => res);
    }
}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/services/dataService.service.ts